<lib-frame-entity-list
  entityName="family"
  [entityConfig]="entityConfig"
  [actions]="tableActions"
  (actionEmitter)="goToCustomAction($event)"
  [defaultActionsFilters]="showDefaultActionsConditions"
></lib-frame-entity-list>
